import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { path } from 'ramda';
import { withAsyncActions } from 'react-async-client';

import { fullAutoOptions } from 'constants/asyncClient';
import { getApplication } from 'actions/asyncActions';

import SidebarContainer from '../../SidebarContainer';
import { ApplicationCard } from './ApplicationCard';

@withAsyncActions({
    getApplication: getApplication.withPayload(({ id }) => id)
}, fullAutoOptions)
export default class ApplicationSidebarView extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired,
        params: PropTypes.object,
        getApplication: PropTypes.object.isRequired
    };

    render() {
        const { params, getApplication: { data, meta, refresh } } = this.props;

        const title = path(['vacancy', 'name'], data) || params.title;

        return (
            <SidebarContainer meta={meta} refresh={refresh} title={title}>
                {meta.success && (
                    <ApplicationCard item={data} />
                )}
            </SidebarContainer>
        );
    }
}
